const projects = [
  {
    title: 'micro-spotify',
    description: 'A microservice to simplify authorizing with Spotify\'s API via the Oauth2 Authorization code flow.',
    url: 'https://github.com/ntaylor89/micro-spotify'
  },
  {
    title: 'spotable',
    description: 'A react-app that helps users build better Spotify playlists using track data from the API',
    url: 'https://github.com/ntaylor89/spotable'
  }
]

export default projects




// WEBPACK FOOTER //
// ./src/data/projects.js